import React from 'react';

import { SidebarThemeContext } from 'src/context';
import { DiamondIcon } from 'src/legacy/components/Icons';
import { white } from 'src/theme/colors';

/**
 *
 * @param props
 * @description Renders diamond icon that represent the advanced feature and is exclusive to higher plans.
 * @returns JSX
 */
export const UpgradeBadge = ({ show = false }) => {
  const { sidebarTextColor } = React.useContext(SidebarThemeContext);
  return show ? (
    <DiamondIcon
      data-testid="upgrade-icon"
      style={{ fontSize: 16, color: sidebarTextColor || white }}
    />
  ) : null;
};
